import type { ButtonProps } from '#ui/types';

export type PaletteBgColors = Extract<ButtonProps['color'], 'neutral' | 'primary' | 'secondary'> | 'black' | 'white' | 'primary-dark';
type ValuesOf<T> = T[keyof T];

const COLORS: Record<PaletteBgColors, string> = {
    black: 'bg-black',
    white: 'bg-white',
    neutral: 'bg-neutral-500',
    primary: 'bg-primary-500',
    'primary-dark': 'bg-primary-950',
    secondary: 'bg-secondary-500',
};

const TEXT_COLORS: Record<PaletteBgColors, string> = {
    black: 'text-inverted',
    white: 'text-highlighted',
    neutral: 'text-highlighted',
    primary: 'text-inverted',
    'primary-dark': 'text-inverted',
    secondary: 'text-highlighted',
};

export const getBgClass = (color: PaletteBgColors): ValuesOf<typeof COLORS> => COLORS[color];

export const getTextClass = (bgColor: PaletteBgColors): ValuesOf<typeof TEXT_COLORS> => TEXT_COLORS[bgColor];
